/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getImport } from '../fn/supervisely/get-import';
import { GetImport$Params } from '../fn/supervisely/get-import';
import { ImportDto } from '../models/import-dto';
import { ImportDtoPage } from '../models/import-dto-page';
import { importFromTar } from '../fn/supervisely/import-from-tar';
import { ImportFromTar$Params } from '../fn/supervisely/import-from-tar';
import { listImports } from '../fn/supervisely/list-imports';
import { ListImports$Params } from '../fn/supervisely/list-imports';
import { updateProjectCount } from '../fn/supervisely/update-project-count';
import { UpdateProjectCount$Params } from '../fn/supervisely/update-project-count';

@Injectable({ providedIn: 'root' })
export class SuperviselyApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listImports()` */
  static readonly ListImportsPath = '/v0/supervisely';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listImports()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImports$Response(params?: ListImports$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportDtoPage>> {
    return listImports(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listImports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImports(params?: ListImports$Params, context?: HttpContext): Observable<ImportDtoPage> {
    return this.listImports$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportDtoPage>): ImportDtoPage => r.body)
    );
  }

  /** Path part for operation `importFromTar()` */
  static readonly ImportFromTarPath = '/v0/supervisely';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importFromTar()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importFromTar$Response(params: ImportFromTar$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportDto>> {
    return importFromTar(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importFromTar$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importFromTar(params: ImportFromTar$Params, context?: HttpContext): Observable<ImportDto> {
    return this.importFromTar$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportDto>): ImportDto => r.body)
    );
  }

  /** Path part for operation `getImport()` */
  static readonly GetImportPath = '/v0/supervisely/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getImport()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImport$Response(params: GetImport$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportDto>> {
    return getImport(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getImport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImport(params: GetImport$Params, context?: HttpContext): Observable<ImportDto> {
    return this.getImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportDto>): ImportDto => r.body)
    );
  }

  /** Path part for operation `updateProjectCount()` */
  static readonly UpdateProjectCountPath = '/v0/supervisely/{id}/project-count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProjectCount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProjectCount$Response(params: UpdateProjectCount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateProjectCount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProjectCount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProjectCount(params: UpdateProjectCount$Params, context?: HttpContext): Observable<void> {
    return this.updateProjectCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
